import { Helmet } from "react-helmet";
import React from "react";

interface MetaData {
    title:string,
    description:string,
    url:string,
    favicon?:string,
    shareImage?:string,
    org?:Org,
    
}

interface Org {
    name:string,
    orgUrl:string,
    logo:string,
    phone:string,
    email:string,
}

const Meta: React.FC<MetaData> = ({title,description,url,favicon,shareImage,org}) => {

    return (
        <Helmet>
            {/* page info */}
            {title!=='undefined' && <title>{title}</title>}
            {description !=='undefined'&& <meta name="description" content={`${description}`}/>}
            <link rel="icon" type="image/png" href={`${favicon}`} />

            {/*org info */}
            <script type="application/ld+json">
                {`
                  {
                    "@context": "http://schema.org",
                    "@type": "Organization",
                    "name": "${org?.name}",
                    "url": "${org?.orgUrl}",
                    "logo": "${org?.logo}",
                    "contactPoint": {
                    "@type": "ContactPoint",
                    "telephone": "${org?.phone}",
                    "email": "${org?.email}",
                    "contactType": "customer support"
                    }
                  }
                `}
            </script>

            {/*Open graph */}

            <meta property="og:title" content={`${title}`} />
            <meta property="og:description" content={`${description}`} />
            <meta property="og:image" content={`${shareImage}`} />

            <meta property="og:url" content={`${url}`} />
            <meta property="og:type" content="website" />

            {/*Twitter */}

            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={`${title}`} />
            <meta name="twitter:description" content={`${description}`}/>
            <meta name="twitter:image" content={`${shareImage}`} />



        </Helmet>
    )

}

export default Meta;